const CARDS = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20still%20of%20two%20detectives%20investigating%20in%20a%20dimly%20lit%20office%20with%20evidence%20board%2C%20crime%20drama%20mood%2C%20warm%20amber%20lighting%2C%20film%20poster%20quality&width=640&height=420&seq=card-01&orientation=landscape',
    title: '2024年必看国产悬疑剧推荐',
    desc: '盘点今年最值得追的国产悬疑剧，高能反转烧脑不停，悬疑迷不可错过的片单精选。',
    tag: '编辑精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20scene%20with%20a%20couple%20silhouette%20against%20sunset%20sky%20in%20a%20city%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20composition%2C%20film%20poster%20aesthetic&width=640&height=420&seq=card-02&orientation=landscape',
    title: '暑期档高分爱情电影特辑',
    desc: '盛夏炎炎，不如窝在家里看几部甜到心坎里的高分爱情电影，治愈一整个夏天。',
    tag: '主题策划',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20ancient%20Chinese%20battle%20scene%20with%20warriors%20and%20banners%2C%20dramatic%20sky%2C%20cinematic%20scale%2C%20warm%20earthy%20tones%2C%20film%20poster%20quality%2C%20historical%20drama%20aesthetic&width=640&height=420&seq=card-03&orientation=landscape',
    title: '古装权谋剧高分榜',
    desc: '宫斗权谋、朝堂风云，精选国产古装剧口碑佳作，感受历史洪流中的人性与智慧较量。',
    tag: '片单推荐',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20family%20gathering%20scene%20in%20a%20warm%20living%20room%20watching%20TV%20together%2C%20soft%20evening%20lighting%2C%20cinematic%20composition%2C%20happy%20atmosphere&width=640&height=420&seq=card-04&orientation=landscape',
    title: '全家欢影视片单',
    desc: '周末全家一起看电影！精选适合各年龄段的优质影视内容，老人孩子都能看，共享温馨家庭时光。',
    tag: '合家欢',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20thrilling%20horror%20scene%20with%20eerie%20atmosphere%20and%20mysterious%20shadows%20in%20an%20old%20house%2C%20cinematic%20lighting%2C%20suspenseful%20mood%2C%20film%20poster%20quality%2C%20dark%20tones&width=640&height=420&seq=card-05&orientation=landscape',
    title: '深夜慎入：高分恐怖片精选',
    desc: '给胆大的你准备的深夜片单，全球精选高分恐怖惊悚佳作，一个人关灯看效果最佳。',
    tag: '类型精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20colorful%20anime%20style%20scene%20with%20diverse%20anime%20characters%20gathered%20together%2C%20vibrant%20colors%2C%20dynamic%20composition%2C%20Japanese%20animation%20aesthetic%2C%20high%20quality%20art&width=640&height=420&seq=card-06&orientation=landscape',
    title: '2024夏季新番追番指南',
    desc: '七月新番全面开播，本季有哪些值得一追的动漫？收好这份追番指南，精彩不错过。',
    tag: '动漫指南',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20documentary%20style%20nature%20scene%20with%20vast%20landscape%20and%20dramatic%20sky%2C%20cinematic%20photography%2C%20natural%20lighting%2C%20educational%20and%20beautiful%2C%20film%20poster%20quality&width=640&height=420&seq=card-07&orientation=landscape',
    title: '涨知识的高分纪录片合集',
    desc: '从自然奇观到人文历史，精选豆瓣高分纪录片，让你在观影中开阔视野、增长见识。',
    tag: '知识充电',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">精选推荐</h2>
          <p className="text-sm text-foreground-500 mt-2">编辑团队为你精选的观影指南和片单推荐</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARDS.map((card) => (
            <div
              key={card.title}
              className="rounded-2xl overflow-hidden bg-background-50 group cursor-pointer hover:bg-background-100 transition-colors"
              data-product-shop=""
            >
              <div className="relative h-[200px] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] font-semibold bg-accent-500 text-background-50 px-2 py-1 rounded-full">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 via-transparent to-transparent" />
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 mb-2 font-heading group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}